module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if(!isLoggedInUser) {  ;
__p += '\n    <span class="user-color" style="background:' +
__e( backgroundColor ) +
'"></span>\n    <ul class="info-user">\n        <li class="user-name">Name here</li>\n        <li class="user-confirmed">Unconfirmed status here</li>\n        <li class="user-email">Email here</li>\n        ';
 if (accessedAt) { ;
__p += '\n            <li class="accessed-at"></li>\n        ';
 } ;
__p += '\n    </ul>\n\n    <div class="info-permission">\n        <div class="user-permissions-change-options">\n            <select class="user-permissions-select form-control"></select>\n            <div class="actions-panel">\n                <span class="delete hidden" data-content="Permanently delete this user from the company" data-original-title="" title=""></span>\n            </div>\n        </div>\n        <input type="text" class="user-permissions-display" disabled readonly/>\n    </div>\n';
 }  ;
__p += '\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/settings/manageAccount/ManageUsersItemView.tpl
// module id = 3113
// module chunks = 0